import {CtControlConfiguration} from "@ctsolution/ct-framework";

export const OfferSearchControl: CtControlConfiguration = <CtControlConfiguration>{
  name: "offerSearch",
  label: "offerSearch.placeholder"
};
